window.intlTelInput = require('intl-tel-input')
import 'intl-tel-input/build/js/intlTelInput-jquery'
import tippy from 'tippy.js'

(function ($) {

  "use strict";

  function Common () {
    let bindHeaderLinks = function ($headerLinks, $nav, $navTrigger) {
      let $headerLinkTriggers = $('.js-header-link-trigger', $headerLinks);
      $headerLinkTriggers.on('click', function (event) {
        event.stopPropagation();
        let $thisHeaderLink = $(this).closest($headerLinks);
        $thisHeaderLink.toggleClass('is-drop-active');
        $headerLinks.not($thisHeaderLink).removeClass('is-drop-active');
        $nav.removeClass('is-active');
        $navTrigger.removeClass('is-active');
      })
    };
    
    let bindNav = function ($navTrigger, $nav, $headerLinks) {
      $navTrigger.on('click', function (event) {
        event.stopPropagation();
        $(this).toggleClass('is-active');
        $nav.toggleClass('is-active');
        $headerLinks.removeClass('is-drop-active');
      });
    };
    
    let bindMobileLang = function ($mobileLangTrigger, $mobileLang) {
      $mobileLangTrigger.on('click', function (event) {
        event.stopPropagation();
        $mobileLang.toggleClass('is-lang-active');
      });
    };
    
    let bindFooterList = function ($footerListTrigger, $footerList) {
      $footerListTrigger.on('click', function () {
        $(this).toggleClass('is-active');
        $(this).siblings($footerList).toggleClass('is-active');
      });
    };

    let bindPreformatAccordionBuild = function ($preformatAccordions) {
      var btnType = $preformatAccordions.data('accordion');
      var $btn = $(btnType, $preformatAccordions);

      $btn.on('click', function () {
        var $self = $(this);

        $self.next('div').toggleClass('is-visible');
        $self.toggleClass('is-active');
      });
    };
    
    let bindSmoothScrollToElement = function () {
      // handle links with @href started with '#' only
      $(document).on('click', 'a[href^="#"]:not([data-toggle="tab"],.js-magnific-inline)', function(e) {
        // target element id
        var id = $(this).attr('href');

        // target element
        var $id = $(id);
        if ($id.length === 0) {
          return;
        }

        // prevent standard hash navigation (avoid blinking in IE)
        e.preventDefault();

        // top position relative to the document
        var pos = $id.offset().top;

        // animated top scrolling
        $('body, html').animate({scrollTop: pos});
      });
    };

    let initTooltips = function (selector) {
      tippy(selector);
    };
    
    let initIntlTelInput = function ($intlTelInput) {
      $intlTelInput.each(function () {
        let id = $(this).attr('id');

        var input = document.querySelector('#' + id);
        
        window.intlTelInput(input, {
          //separateDialCode: true,
          autoPlaceholder: 'off',
          nationalMode: false,
          initialCountry: 'auto',
          utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.min.js'
        });
      });
    };

    let init = function (parentElement) {
      let $header = $('.js-header', parentElement);
      let $footer = $('.js-footer', parentElement);
      let $preformatAccordions = $('.js-preformat-accordions', parentElement);
      let tooltipSelector = '.js-tooltip';
      let $intlTelInput = $('.js-intlTelInput', parentElement);
      let $stickySidebar = $('.js-sticky-sidebar', parentElement);
      let $pillSwitchTrigger = $('.js-pill-switch-trigger', parentElement);
 
      $('.wpcf7').on('wpcf7mailsent', function() {
        window.scroll({
          top: $(this).closest('.p-contact__form').offset().top - 100,
          behavior: 'smooth'
        })
      }).on('wpcf7submit', function() {
        window.scroll({
          top: $(this).closest('.p-contact__form').offset().top,
          behavior: 'smooth'
        })
      })

      if ($header.length) {
        let $headerLinks = $('.js-header-link', $header);
        let $nav = $('.js-nav', $header);
        let $navTrigger = $('.js-nav-trigger', $header);
        let $mobileLang = $('.js-mobile-lang', $header);
        let $mobileLangTrigger = $('.js-mobile-lang-trigger', $mobileLang);

        $(window).click(function() {
          $headerLinks.removeClass('is-drop-active');
          $nav.removeClass('is-active');
          $navTrigger.removeClass('is-active');
        });

        bindHeaderLinks($headerLinks, $nav, $navTrigger);
        bindNav($navTrigger, $nav, $headerLinks);
        bindMobileLang($mobileLangTrigger, $mobileLang);
        bindSmoothScrollToElement();
      }
      
      if ($footer.length) {
        let $footerList = $('.js-footer-list', $footer);
        let $footerListTrigger = $('.js-footer-list-trigger', $footer);
        
        bindFooterList($footerListTrigger, $footerList);
      }

      if ($preformatAccordions.length) {
        bindPreformatAccordionBuild($preformatAccordions);
      }

      if ($(tooltipSelector, parentElement).length) {
        initTooltips(tooltipSelector);
      }
      
      if ($intlTelInput.length) {
        initIntlTelInput($intlTelInput);
      }

      if ($stickySidebar.length) {
        var top = $stickySidebar.offset().top;

        $stickySidebar.css('width', $stickySidebar.width());

        if (DeviceSelector.desktop() && ($(window).height() > $stickySidebar.height())) {
          $(window).scroll(function(event) {
            var scrollTop = $(this).scrollTop();

            // sidebar reached the (end - viewport height)
            if (scrollTop >= top) {
              $stickySidebar.addClass('fixed');
            } else {
              // otherwise remove it
              $stickySidebar.removeClass('fixed');
            }
          });
        }
      }
    };

    this.init = function (element) {
      let parentElement = element ? element : $('body');
      init(parentElement);
    };
  }

  window.Common = new Common();

})(jQuery);
